import reduceReducers from 'reduce-reducers';

//Siblings reducers
import preferredSiteReducer from './preferred-site-reducer';

export default reduceReducers(preferredSiteReducer);
